import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

async function authHeaders(getToken) {
  const token = await getToken();
  if (!token) {
    throw new Error('You must be signed in to view contact submissions.');
  }
  return { Authorization: `Bearer ${token}` };
}

export async function listContactSubmissions(getToken) {
  const headers = await authHeaders(getToken);
  const res = await axios.get(`${API}/contact`, { headers });
  return res.data;
}

export async function getContactSubmission(id, getToken) {
  const headers = await authHeaders(getToken);
  const res = await axios.get(`${API}/contact/${id}`, { headers });
  return res.data;
}

export async function updateContactSubmission(id, payload, getToken) {
  const headers = await authHeaders(getToken);
  const res = await axios.patch(`${API}/contact/${id}`, payload, { headers });
  return res.data;
}

export async function replyToContactSubmission(id, replyMessage, getToken) {
  return updateContactSubmission(id, { replyMessage, status: 'replied' }, getToken);
}

export async function markContactSubmissionReviewed(id, getToken) {
  return updateContactSubmission(id, { status: 'reviewed' }, getToken);
}
